import Single_Dashboard_Image from "../../assets/Single_Dashboard.png";
import { decorateDashboardRouteMeta } from "./dashboardRouteUtils";

export const setToken = (token, userId, role, accountId) => {
  localStorage.setItem("jwtToken", token);
  localStorage.setItem("isUserLoggedIn", true);
  localStorage.setItem("userId", userId);
  localStorage.setItem("role", role);
  if (accountId && accountId !== "None") {
    localStorage.setItem("accountId", accountId);
  } else {
    localStorage.removeItem("accountId");
  }
};

// Function to get the JWT token from local storage
export const getToken = () => {
  return localStorage.getItem("jwtToken");
};

export const getUserId = () => {
  return localStorage.getItem("userId");
};

export const getUserRole = () => {
  return localStorage.getItem("role");
};
// Function to remove the JWT token from local storage
export const verifyLogin = () => {
  return Boolean(
    localStorage.getItem("isUserLoggedIn") &&
      getToken() &&
      getUserId(),
  );
};

export const getAccountId = () => {
  return localStorage.getItem("accountId");
};

export const removeToken = (onRemoved) => {
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("isUserLoggedIn");
  localStorage.removeItem("userId");
  localStorage.removeItem("role");
  localStorage.removeItem("accountId");
  localStorage.removeItem("subscriptionType");

  if (onRemoved && typeof onRemoved === "function") {
    onRemoved();
  }
};

export const setSubscriptionsType = (subscriptionType) => {
  localStorage.setItem("subscriptionType", subscriptionType);
};

export const getSubscriptionsType = () => {
  return localStorage.getItem("subscriptionType");
};

export const getSubscriptionTypes = () => {
  const storedSubscriptionTypes = localStorage.getItem("subscriptionType");

  if (!storedSubscriptionTypes) {
    return [];
  }

  try {
    const parsedSubscriptionTypes = JSON.parse(storedSubscriptionTypes);
    if (Array.isArray(parsedSubscriptionTypes)) {
      return parsedSubscriptionTypes.filter(Boolean);
    }
  } catch {
    // Existing storage writes arrays as comma-separated strings.
  }

  return String(storedSubscriptionTypes)
    .split(",")
    .map((subscriptionType) => subscriptionType.trim())
    .filter(Boolean);
};

export const hasSubscriptionType = (...subscriptionTypes) => {
  const activeSubscriptionTypes = getSubscriptionTypes();
  return subscriptionTypes.some((subscriptionType) =>
    activeSubscriptionTypes.includes(subscriptionType),
  );
};

export const FetchUserDashboards = async (setUserDashboards) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_dashboard/?user_id=${getUserId()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();
    const user_dashboard = data.results.dashboard_details.map((x) => {
      const name = x.dashboard_name;
      const dashboardName = x.data_reference;
      const s3_bucket_name = x.s3_bucket_name;
      const s3_prefix = x.s3_prefix;
      const default_start_date =
        x.details_object !== null && x.details_object["default_start_date"];
      const default_end_date =
        x.details_object !== null && x.details_object["default_end_date"];

      return decorateDashboardRouteMeta({
        name: name,
        dashboardName: dashboardName,
        s3_bucket_name: s3_bucket_name,
        s3_prefix: s3_prefix,
        icon: "fa-solid fa-chart-simple p-2 ",
        image: Single_Dashboard_Image,
        default_start_date: default_start_date,
        default_end_date: default_end_date,
      });
    });
    setUserDashboards(user_dashboard); // update state with user_dashboard;
  } catch (error) {
    console.log(error);
  }
};

export const fetchUserSubscriptions = async (setUserSubscriptions,setSubscriptionLoading) => {

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = getToken();

  try {
    setSubscriptionLoading(true);
    if (!apiUrl || !token) {
      setUserSubscriptions([]);
      return;
    }

    const response = await fetch(`${apiUrl}/auth/get_subscription`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    if (!response.ok || !data?.results?.subscription_detail) {
      throw new Error("Unable to fetch subscriptions");
    }

    const user_subscriptions = data.results.subscription_detail;
    const filtered_subscription = user_subscriptions.filter((x) => {
      return (
        x.subscription_type.includes("EMALPHA") || x.subscription_type.includes("INTERNAL") 
      );
    });
    const subscriptionType = user_subscriptions.map((x) => x.subscription_type);
    setSubscriptionsType(subscriptionType);
    setUserSubscriptions(filtered_subscription);
  } catch (error) {
    console.log(error);
    setUserSubscriptions([]);
  }
  finally{
    setSubscriptionLoading(false);
  }
};

export const decodeJWT = (token) => {
  const payloadPart = token.split(".")[1]; // Extract the payload
  const decodedPayload = atob(
    payloadPart.replace(/-/g, "+").replace(/_/g, "/")
  );
  const payloadObject = JSON.parse(decodedPayload);
  return payloadObject;
};

export const fetchWebSocketToken = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = getToken();

  if (!apiUrl || !token) {
    throw new Error("Missing API URL or auth token for websocket auth");
  }

  const response = await fetch(`${apiUrl}/ws/v2/auth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();
  if (!response.ok || !data?.success || !data?.results?.ws_token) {
    throw new Error(data?.errorObject?.message || "Unable to create websocket token");
  }

  return data.results.ws_token;
};

export const getAuthenticatedWebSocketUrl = async (
  chatId,
  userId,
  messageId,
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const wsToken = await fetchWebSocketToken();
  const apiHost = new URL(apiUrl).host;
  const wsProtocol = apiUrl.startsWith("https") ? "wss" : "ws";
  const params = new URLSearchParams({
    ws_token: wsToken,
  });

  if (messageId) {
    params.set("message_id", messageId);
  }

  return `${wsProtocol}://${apiHost}/ws/v2/${encodeURIComponent(
    chatId
  )}/${encodeURIComponent(userId)}?${params.toString()}`;
};

export const getDemoWebSocketUrl = (chatId) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  if (!apiUrl) {
    throw new Error("Missing API URL for demo websocket");
  }

  const apiHost = new URL(apiUrl).host;
  const wsProtocol = apiUrl.startsWith("https") ? "wss" : "ws";
  const params = new URLSearchParams({
    chat_id: chatId,
  });

  return `${wsProtocol}://${apiHost}/demo/ws?${params.toString()}`;
};
